'use client';

import { c as _c } from "react/compiler-runtime";
import Footer from '@components/footer/Footer';
import Header from '@components/header/Header';
import MenuMobile from '@components/menu-mobile/MenuMobile';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import style from './BaseLayout.module.scss';
const CookiePopup = dynamic(() => import('@components/cookie-popup/CookiePopup'));
function BaseMobileLayout(t0) {
  const $ = _c(21);
  const {
    menuMobile,
    isANewUser,
    children,
    commonModals,
    renderFooter,
    isMobile,
    isLandscape,
    deviceType
  } = t0;
  const [isClient, setIsClient] = useState(false);
  const containerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsClient(true);
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (isLandscape && isClient && isMobile) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className={style.layoutPlug}>Для корректной работы сайта, пожалуйста, переверните устройство</div>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== menuMobile) {
    t3 = menuMobile && <MenuMobile />;
    $[3] = menuMobile;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== deviceType || $[6] !== isMobile) {
    t4 = <Header isMobile={isMobile} deviceType={deviceType} />;
    $[5] = deviceType;
    $[6] = isMobile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isANewUser) {
    t5 = !isANewUser && <CookiePopup />;
    $[8] = isANewUser;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== renderFooter) {
    t6 = renderFooter && <Footer />;
    $[10] = renderFooter;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div ref={containerRef} className="App">{t4}{t5}{children}{t6}</div>;
    $[12] = children;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== commonModals || $[18] !== t3 || $[19] !== t7) {
    t8 = <>{t3}{commonModals}{t7}</>;
    $[17] = commonModals;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
export default BaseMobileLayout;